export default __webpack_public_path__ + "static/media/earth_white.b0d834ac.svg";